module.exports = "/assets/8913993da4747b34db80dd049c57e301.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cars/assets/logos/ZT.png
// module id = 770
// module chunks = 0